import { createRowActions, DataTable, type DataTableVariant } from "@msuite/ui/table";
import type * as Schemas from "@msuite/utils/schemas";
import type React from "react";
import { transportOrdersTableColumns } from "@/components/stock";
import { RowActions } from "./row-actions";
import { useTransportOrders } from "@/hooks/use-transport-orders";

/** Props Interface */
interface TransportOrdersTableProps {
	menu?: React.ReactNode;
	variant?: DataTableVariant;
	query?: Schemas.GetTransportOrdersQuerySchema;
}

/**
 * The transport legs the warehouse currently owes, as the office reads them.
 *
 * It lists legs rather than carriers, which is the same distinction the domain makes everywhere: a
 * box crossing three zones appears three times over its life, once per hop, because each hop is a
 * separate piece of work somebody accepts and finishes. Two rows naming the same carrier are
 * therefore ordinary — one delivered, one still to fetch.
 */
export function TransportOrdersTable({
	menu = null,
	variant = "table",
	query,
}: TransportOrdersTableProps) {
	/** Hooks */
	const { transportOrders, isLoading, queryKey, refetch } = useTransportOrders(query);

	/** Render */
	return (
		<DataTable
			data={transportOrders}
			columns={[...transportOrdersTableColumns, createRowActions(RowActions)]}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			menu={menu}
			persistenceKey="data-transport-orders-table"
			variant={variant}
		/>
	);
}
